import { Component } from '@angular/core';


export class SkyToolbarDemoComponent { static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-toolbar-demo',
  template: `<sky-toolbar>
  <sky-toolbar-item>
    <button class="sky-btn sky-btn-default">Button 1</button>
  </sky-toolbar-item>
  <sky-toolbar-item>
    <button class="sky-btn sky-btn-default">Button 2</button>
  </sky-toolbar-item>
</sky-toolbar>
`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
